import PropTypes from 'prop-types';
import { colors } from '../colors';

const Sifra = ({
  onClick,
  displayValue,
  color = colors.INFO,
  fontWeight = 600,
}) => {
  return (
    <div onClick={onClick}>
      <span
        style={{
          textDecoration: 'underline',
          color: color,
          cursor: 'pointer',
          fontWeight: fontWeight,
        }}
      >
        {displayValue}
      </span>
    </div>
  );
};

export default Sifra;

Sifra.propTypes = {
  onClick: PropTypes.func.isRequired,
  displayValue: PropTypes.string.isRequired,
};
